import { api } from '../middleware/api';

// Define endpoints using injectApi pattern
export const bqreportsApi = api
  .enhanceEndpoints({ addTagTypes: ['BQReports'] })
  .injectEndpoints({
    endpoints: builder => ({
      getBQReports: builder.query<any, any>({
        query: ({ cid, fdt, tdt }) => `bqreports/cashier/${cid}/${fdt}/${tdt}`
      }),
      getBQTax: builder.query<any, any>({
        query: ({ cid, fdt, tdt }) => `bqreports/tax/${cid}/${fdt}/${tdt}`
      }),
      getBQSales: builder.query<any, any>({
        query: ({ cid, fdt, tdt }) => `bqreports/sales/${cid}/${fdt}/${tdt}`
      }),
      getBQBooking: builder.query<any, any>({
        query: ({ cid, fdt, tdt }) => `bqreports/booking/${cid}/${fdt}/${tdt}`
      })
    }),
    overrideExisting: false
  });

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetBQReportsQuery,
  useGetBQTaxQuery,
  useGetBQBookingQuery,
  useGetBQSalesQuery
} = bqreportsApi;

